module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-04.3bdf0ec2.svg";